import { render, staticRenderFns } from "./account-confirm.vue?vue&type=template&id=b8fa5638"
import script from "./account-confirm.vue?vue&type=script&lang=ts"
export * from "./account-confirm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports